import { render, staticRenderFns } from "./OfferLimitsTab.vue?vue&type=template&id=f5ccbe68&"
import script from "./OfferLimitsTab.vue?vue&type=script&lang=ts&"
export * from "./OfferLimitsTab.vue?vue&type=script&lang=ts&"
import style0 from "./OfferLimitsTab.vue?vue&type=style&index=0&id=f5ccbe68&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports